export enum EStrokeWidth {
  ICON_LIGHT = 1,
  ICON_DEFAULT = 1.2,
}
